import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.volunteerApiBaseUrl;

export default {
    async fetchThankYouMessages(query) {
        const url = `${URL}v1/cms/thank-you-messages${query}`;
        return (await httpClient.get(url)).data;
    },
};
